export const listModel = {
    /*extreme: {
        id: 'extreme',
        name: "Premium Plus",
        model: "gpt-5.2-pro",
        price: 0.75,
        description: "Qualité maximale"
    },*/
    premium: {
        id: 'premium',
        name: "Premium",
        model: "gpt-5.1",
        price: 0.22,
        description: "Excellent rapport qualité/prix",
        time: "Entre 10 et 12 minutes",
        qualityScore: 10
    },
    pro: {
        id: 'pro',
        name: "Professionnel",
        model: "gpt-4o",
        price: 0.012,
        description: "Rapide et efficace",
        time: "Entre 1 minutes 30 et 2 minutes 30",
        qualityScore: 9
    },
    default: {
        id: 'default',
        name: "Standard",
        model: "gpt-4o-mini",
        price: 0.007,
        description: "Économique",
        time: "Entre 2 minutes 30 et 3 minutes 30",
        qualityScore: 6
    },
    free: {
        id: 'free',
        name: "Éco",
        model: "gpt-5-nano",
        price: 0.005,
        description: "Basique",
        time: "Entre 14 minutes et 16 minutes",
        qualityScore: 2
    }
};

export type ModelKey = keyof typeof listModel;
